import { useMemo, useState } from 'react'
import { LOCAL_STORAGE_THEME_KEY, Theme, ThemeContext } from '../lib/theme-context'

const defaultTheme = (localStorage.getItem(LOCAL_STORAGE_THEME_KEY) as Theme) || Theme.LIGHT

interface ThemeProviderProps {
    children: JSX.Element
    initialTheme?: Theme
}

export function ThemeProvider({ initialTheme, children }: ThemeProviderProps) {
    const [theme, setTheme] = useState<Theme>(initialTheme || defaultTheme)

    const defaultProps = useMemo(() => ({ theme, setTheme }), [theme])

    return <ThemeContext.Provider value={defaultProps}>{children}</ThemeContext.Provider>
}
